import { render, staticRenderFns } from "./QuestionCategoryModule.vue?vue&type=template&id=fbf70e1a&"
import script from "./QuestionCategoryModule.vue?vue&type=script&lang=js&"
export * from "./QuestionCategoryModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports